import PhoneInput from './PhoneInput.view';

export default PhoneInput;
